export const INTL_SITE_URL = "https://en.caffeina.com/";
export const HOME_COUNTRY = "IT";
export const BYPASS_QUERY_PARAM = "from_intl";
export const COUNTRY_COOKIE = "cf_country";
export const STORAGE_KEY = "geo_banner_dismissed";
export const DISMISS_TTL_MS = 24 * 60 * 60 * 1000;
export const GEO_ACCENT_LIME = "#EBFE50";
export const GEO_MODAL_BG = "#434343";
export const GEO_DISMISS_BG = "#232323";
export const GEO_OVERLAY_Z_INDEX = 2147483647;

// Paths where banner must NOT appear (Italian-only content)
export const EXCLUDED_PATHS = [
  "/case-studies",
  "/jobs",
  "/careers",
  "/work-with-us",
];
